import { all } from "redux-saga/effects";
import userSaga from "./user";
import librarySaga from "./library";
import calendarSaga from "./calendar";
import clientsSaga from "./clients";
import singleClientSaga from "./single-client";
import listsSaga from "./lists";
import singleListSaga from "./single-list";
import newListSaga from "./new-list";
import overviewSaga from "./overview";
import newSpaceSaga from "./new-space";
import validateSaga from "./validate";
import companySaga from "./company";
import pipelineSaga from "./pipeline";
import registrationSaga from "./registration";
import invitationSaga from "./invitation";
import deliveriesSaga from "./deliveries";
import campaignsSaga from "./campaigns";
import contactListsSaga from "./contact-lists";
import templatesSaga from "./templates";
import newTemplateSaga from "./new-template";
import singleTemplateSaga from "./single-template";
import authenticationSaga from "./authentication";
import resetPasswordSaga from "./reset-password";
import singleContactListSaga from "./single-contact-list";
import singleCampaignSaga from "./single-campaign";

export default function* rootSaga() {
  yield all([
    userSaga(),
    librarySaga(),
    calendarSaga(),
    clientsSaga(),
    singleClientSaga(),
    listsSaga(),
    singleListSaga(),
    newListSaga(),
    overviewSaga(),
    newSpaceSaga(),
    validateSaga(),
    companySaga(),
    pipelineSaga(),
    registrationSaga(),
    invitationSaga(),
    resetPasswordSaga(),
    deliveriesSaga(),
    campaignsSaga(),
    contactListsSaga(),
    singleContactListSaga(),
    templatesSaga(),
    newTemplateSaga(),
    singleTemplateSaga(),
    singleCampaignSaga(),
    authenticationSaga(),
  ]);
}
